import React, { useState } from "react";
import { Row, Col, Drawer, Card, Avatar } from "antd";
import styles from "../../Grocery/GroceryShopping/GroceryShopping.module.scss";
import { rightOutlined } from "../../../assets/images";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import groceryAvatar from "../../../assets/icons/groceryAvatar.svg";
import rideAvatar from "../../../assets/icons/rideAvatar.svg";
import defaultImage from "../../../assets/images/uploadPic.svg";
import drawerStyles from "../../../components/DashBoard/TripDetails/TripDetailsDrawer.module.scss";
import { Spinner } from "@mtm/components";
import { useDashboardCtx } from "../../../context/DashboardContext";
import { useHistory } from "react-router";
import { usePaginationCtx } from "../../../context/PaginationContext";
import { usePersonSummaryCtx } from "../../../context/PersonSummaryContext";
import { IServiceUserInfo } from "../../../types/ServiceUserInfo";
import { useGroceryCtx } from "../../../context/GroceryContext";
import { defaultDeliveryAddress, defaultSelectedAddress } from "../../../types/LocationTypes";
type Props = {
  profile: IServiceUserInfo;
  isServiceSelectionDrawer: boolean;
  setIsServiceSelectionDrawer: Function;
};

function ServiceSelectionDrawer({
  profile,
  isServiceSelectionDrawer,
  setIsServiceSelectionDrawer,
}: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { selectedPersonIdCtx, serviceDataCtx } = useDashboardCtx();
  const [selectedPersonId, setSelectedPersonId] = selectedPersonIdCtx;
  const { caregiverSummaryInfo } = usePersonSummaryCtx();
  const history = useHistory();

  const { deliveryAddressCtx, isDeliveryScheduledCtx } = useGroceryCtx();
  const [deliveryAddress, setDeliveryAddress] = deliveryAddressCtx;
  const [, setIsDeliveryScheduled] = isDeliveryScheduledCtx;

  const redirect = (url: string) => {
    history.push(url);
  };
  const handleScheduleServiceButtonClick = () => {
    redirect(
      `/DashBoard/ScheduleService/ScheduleServiceCalender/${caregiverSummaryInfo.personId}/${selectedPersonId}`
    );
    setIsServiceSelectionDrawer(false);
  };

  function resetGrocerySetup() {
    if (deliveryAddress?.organizationId)
      setDeliveryAddress(defaultDeliveryAddress);

    setIsDeliveryScheduled(false);
  }

  const handleGroceryServiceButtonClick = () => {
    resetGrocerySetup();
    setIsServiceSelectionDrawer(false);
    redirect(`/DashBoard/GroceryDelivery/${selectedPersonId}`);
  };

  const handleClose = () => {
    setIsServiceSelectionDrawer(false);
  };

  return (
    <>
      <Drawer
        placement="right"
        title={
          <>
            <Row gutter={[0, 14]}>
              <Col span={24} className={textStyles.normalText20}>
                Schedule Service
              </Col>
            </Row>
            <Row justify="center" className={styles.imageContainer}>
              <Col>
                <Avatar
                  size={104}
                  src={profile.profileImageUrl || defaultImage}
                  alt="profile_picture"
                  className={styles.avatar}
                />
              </Col>
            </Row>
            <Row justify="center" className={styles.nameRow}>
              <Col>
                <Col className={styles.userNameStyle}>
                  {profile?.firstName} {profile?.lastName}
                </Col>
              </Col>
            </Row>
            <Row justify="center">
              <Col>
                <Col className={styles.serviceType}>Select a service type</Col>
              </Col>
            </Row>
          </>
        }
        className={drawerStyles.drawerContainer}
        onClose={handleClose}
        visible={isServiceSelectionDrawer}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <div className={styles.gradientBorder} />
            <Row className={styles.sectionContainer}>
              <Card className={styles.transportationCardStyle}>
                <Row align="middle" className={styles.sectionRow}>
                  <Col span={3} className={styles.iconCol}>
                    <img
                      className={styles.sectionImgStyle}
                      src={rideAvatar}
                      alt="rideAvatar-Icon"
                    />
                  </Col>
                  <Col span={19} className={styles.textCol}>
                    <div className={textStyles.boldText20}>Transportation</div>
                    <div className={styles.normalText14}>
                      Take a ride from point A to point B.
                    </div>
                  </Col>
                  <Col
                    span={2}
                    className={styles.sectionArrowCol}
                    onClick={handleScheduleServiceButtonClick}
                  >
                    <img src={rightOutlined} alt="rightOutlined_icon" />
                  </Col>
                </Row>
              </Card>

              <Card
                className={`${styles.sectionCard} ${styles.groceryCardStyle}`}
              >
                <Row align="middle" className={styles.sectionRow}>
                  <Col span={3} className={styles.iconCol}>
                    <img
                      className={styles.sectionImgStyle}
                      src={groceryAvatar}
                      alt="grocery-Icon"
                    />
                  </Col>
                  <Col span={19} className={styles.textCol}>
                    <div className={textStyles.boldText20}>
                      Grocery delivery
                    </div>
                    <div className={styles.normalText14}>
                      Fresh groceries and more, straight to your door.
                    </div>
                  </Col>
                  <Col
                    span={2}
                    className={styles.sectionArrowCol}
                    onClick={handleGroceryServiceButtonClick}
                  >
                    <img src={rightOutlined} alt="rightOutlined_icon" />
                  </Col>
                </Row>
              </Card>
            </Row>
          </>
        )}
      </Drawer>
    </>
  );
}

export default ServiceSelectionDrawer;
